import {createRouter, createWebHistory, RouteRecordName, RouteRecordRaw, RouterScrollBehavior} from 'vue-router'
import store from "@/store";
import {NamedRouting} from "@/domain/utils/NamedRouting";
import paycoUtils from "@/assets/js/utils";

const ContactTestView = () => import("@/views/ContactTestView.vue");
const HomeView = () => import('@/views/HomeView.vue');
const ProductListView = () => import('@/views/ProductListView.vue');
const ProductDetailView = () => import('@/views/ProductDetailView.vue');
const MyOrder = () => import('@/views/MyOrderView.vue');
const MyUsableTicketView = () => import('@/views/MyUsableTicketView.vue');
const MyUnusableTicketView = () => import("@/views/MyUnusableTicketView.vue");
const TicketDetail = () => import("@/views/TicketDetailView.vue");
const OrderDetail = () => import("@/views/OrderDetailView.vue");
const PresentView = () => import("@/views/PresentView.vue");
const PurchaseView = () => import("@/views/PurchaseView.vue");
const ReceiverSelectionComponent = () => import("@/components/order/ReceiverSelectionComponent.vue");
const MessageWritingComponent = () => import("@/components/order/MessageWritingComponent.vue");
const ProductOrderComponent = () => import("@/components/order/ProductOrderComponent.vue");
const ChargeCardSelectionComponent = () => import("@/components/order/ChargeCardSelectionComponent.vue");
const PaymentSuccessBridgeView = () => import("@/views/PaymentSuccessBridgeView.vue");
const PaymentSuccessView = () => import("@/views/PaymentSuccessView.vue");
const PaymentFailView = () => import("@/views/PaymentFailView.vue");
const PaymentCancellationHistoryView = () => import("@/views/PaymentCancellationHistoryView.vue");
const RefundingHistoryView = () => import("@/views/RefundingHistoryView.vue");
const PromotionDetailView = () => import("@/views/PromotionDetailView.vue");
const SearchView = () => import("@/views/SearchView.vue");
const SearchResultView = () => import("@/views/SearchResultView.vue");
const OAuthBridgeView = () => import("@/views/OAuthBridgeView.vue");
const NonMemberView = () => import("@/views/NonMemberView.vue");
const NonMemberViewForApp = () => import("@/views/NonMemberViewForApp.vue");

const routes: Array<RouteRecordRaw> = [

  {path: '/:channelId/after-oauth', component: OAuthBridgeView, name: 'OAuthBridgeView'},

  {path: '/:channelId/contact', component: ContactTestView, name: 'ContactTestView'},
  {path: '/:channelId/home', component: HomeView, name: 'HomeView',
    beforeEnter: (to, from, next) => {
      store.commit('AppYnStore/setAppYn', to.query.appYn);
      if (to.query.token) {
        const blankRemovedToken = String(to.query.token).split(' ').join('');
        store.commit('MemberStore/setToken', blankRemovedToken);
        // store.commit('MemberStore/setToken', to.query.token);
        next(new NamedRouting('HomeView', {channelId: to.params.channelId}));
      } else {
        next();
      }
    },
  },

    //promotion
  {path: '/:channelId/promotion/:bannerId', component: PromotionDetailView, props: true, name: 'PromotionDetailView'},

  //product
  {path: '/:channelId/products', component: ProductListView, name: 'ProductListView'},
  {path: '/:channelId/product/:productId', component: ProductDetailView, props: true, name: 'ProductDetailView',
    beforeEnter: (to, from, next) => {
      if (from.path.indexOf('/present') >= 0 || from.path.indexOf('/purchase') >= 0) {
        store.commit('ReceiverStore/initReceiverStore');
      }
      else {
        store.commit('MembershipStore/initMembershipStore');
      }
      next();
    }
  },

  // order
  {path: '/:channelId/purchase', component: PurchaseView, name: 'PurchaseView',
    children: [
      {path: 'write-message', component: MessageWritingComponent, name: 'MessageWritingForPurchase', props:{isForPresent: false}},
      {path: 'order-product', component: ProductOrderComponent, name: 'ProductOrderForPurchase', props:{isForPresent: false}},
      {path: 'select-charge-card', component: ChargeCardSelectionComponent, name: 'ChargeCardSelectionForPurchase'},
    ]
  },

  {path: '/:channelId/present', component: PresentView, name: 'PresentView',
    children: [
      {path: 'select-receiver', component: ReceiverSelectionComponent, name: 'ReceiverSelection'},
      {path: 'write-message', component: MessageWritingComponent, name: 'MessageWritingForPresent', props:{isForPresent: true}},
      {path: 'order-product', component: ProductOrderComponent, name: 'ProductOrderForPresent', props:{isForPresent: true}},
      {path: 'select-charge-card', component: ChargeCardSelectionComponent, name: 'ChargeCardSelectionForPresent'},
    ]
  },

  {path: '/:channelId/order-fail', component: PaymentFailView, name: 'PaymentFailView'},
  {path: '/:channelId/order-success', component: PaymentSuccessBridgeView, name: 'PaymentSuccessBridgeView'},
  {path: '/:channelId/order-completion', component: PaymentSuccessView, name: 'PaymentSuccessView', props: true},

  //my
  {path: '/:channelId/my/tickets/usable', component: MyUsableTicketView, name: 'MyUsableTicketView'},
  {path: '/:channelId/my/tickets/unusable', component: MyUnusableTicketView, name: 'MyUnusableTicketView'},
  {path: '/:channelId/my/orders', component: MyOrder, name: 'MyOrderView'},

  //my -> details
  {path: '/:channelId/my/ticket/:ticketId', component: TicketDetail, name: 'TicketDetailView', props: true},
  {path: '/:channelId/my/order/:orderId', component: OrderDetail, name: 'OrderDetailView', props: true},
  {path: '/:channelId/my/cancellation-history/:ticketId', component: PaymentCancellationHistoryView, name: 'PaymentCancellationHistoryView', props: true},
  {path: '/:channelId/my/refund-history/:ticketId', component: RefundingHistoryView, name: 'RefundingHistoryView', props: true},
  {path: '/:channelId/my/order-cancellation-history/:orderId', component: PaymentCancellationHistoryView, name: 'PaymentCancellationHistoryView', props: true},

  // search
  {path: '/:channelId/search', component: SearchView, name: 'SearchView'},
  {path: '/:channelId/search-result', component: SearchResultView, name: 'SearchResultView'},

  // WEB 에서 비로그인 시, 띄울 로그인/휴대폰인증 유도화면
  {path: '/:channelId/non-member', component: NonMemberView, name: 'NonMemberView', props: true},
  // APP 에서 비로그인 시, 띄울 로그인/휴대폰인증 유도화면
  {path: '/:channelId/non-member-for-app', component: NonMemberViewForApp, name: 'NonMemberViewForApp', props: true},
  // otherwise redirect to home
  // {path: '/:pathMatch(.*)*', redirect: '/'}
];

const scrollBehavior: RouterScrollBehavior = function (to, from, savedPosition) {
  return { top: 0 };
};

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // uris without hashes #, see https://router.vuejs.rorg/guide/essentials/history-mode.html#html5-history-mode
  routes,
  scrollBehavior,
});

// router 네비게이션 순서 중 가장 처음 발생함.
router.beforeEach((to, from, next) => {
  store.commit('ChannelStore/setChannelId', to.params.channelId);
  to.params.channelId = store.state.ChannelStore.channelId;

  if (to.path.indexOf('/my/ticket') >= 0) {
    store.commit('AppYnStore/setAppYn', to.query.appYn);
    if (to.query.token) {
      const blankRemovedToken = String(to.query.token).split(' ').join('');
      store.commit('MemberStore/setToken', blankRemovedToken);
      // store.commit('MemberStore/setToken', to.query.token);
      next(new NamedRouting('TicketDetailView', {channelId: to.params.channelId, ticketId: to.params.ticketId}));
    }
  }

  if (to.path.indexOf('/present') >= 0 || to.path.indexOf('/purchase') >= 0 || to.path.indexOf('/my') >= 0) {
    if (paycoUtils.isEmptyString(store.state.MemberStore.token) && paycoUtils.isEmptyString(store.state.MemberStore.phoneNumber)) {
      if (store.getters['AppYnStore/isApp']) {
        next(new NamedRouting('NonMemberViewForApp', {channelId: to.params.channelId}));
      } else {
        store.commit('NextViewStore/setNextView', new NamedRouting(to.name!, to.params, to.query));
        next(new NamedRouting('NonMemberView', {channelId: to.params.channelId}));
      }
      return;
    }
  }
  next();
});

// 새 페이지 진입 시, 슬라이딩 애니메이션
// router.afterEach((to, from) => {
//   const toDepth = to.path.split('/').length;
//   const fromDepth = from.path.split('/').length;
//   to.meta.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
// });

export default router;